import React from 'react'

import useStyles from './styles'
import { SUCCESS_BOOKING_ANIMATION } from 'src/config/imageUrls'
import clsx from 'clsx'

const SuccessAnimation = ({ className }: { className?: string }) => {
  const classes = useStyles()

  return (
    <div className={classes.animationContainer}>
      <img
        className={clsx(classes.animation, className)}
        src={SUCCESS_BOOKING_ANIMATION}
        alt="success booking animation"
      />
    </div>
  )
}

export default SuccessAnimation
